// Esto es para la autenticacion de forma globaaaal
import { onSessionExpired, refreshAccessToken } from '../services/refreshService';
import { websocketService } from '../services/websocketService';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { recuperarMisCotizaciones } from '../services/misCotizacionesService';
import { fetchCurrentUser, logout as authLogout, User } from '../services/authService';

interface AuthContextType {
    user: User | null;
    isAuthenticated: boolean;
    loading: boolean;
    setUser: React.Dispatch<React.SetStateAction<User | null>>;
    setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
    logout: (destination?: '/' | '/login') => Promise<void>;
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => onSessionExpired(() => {
        websocketService.disconnect();
        setUser(null);
        setIsAuthenticated(false);
        setLoading(false);
    }), []);

    useEffect(() => {
        if (!isAuthenticated) return;
        const timer = window.setInterval(() => {
            refreshAccessToken().catch(() => { /* Terminal 401 clears auth; transient errors can retry. */ });
        }, 60 * 1000);
        return () => window.clearInterval(timer);
    }, [isAuthenticated]);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const userData = await fetchCurrentUser();
                setUser(userData);
                setIsAuthenticated(true);
            } catch (error) {
                setUser(null);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };
    
        checkAuth();
    }, []);

    useEffect(() => {
        if (isAuthenticated && user) {
            recuperarMisCotizaciones().catch(() => { /* Retry when opening Mis cotizaciones. */ });
        }
    }, [isAuthenticated, user?.id]);

    const logout = async (destination: '/' | '/login' = '/login') => {
        await authLogout();
        setUser(null);
        setIsAuthenticated(false);
        window.location.href = destination;
    };

    return (
        <AuthContext.Provider value={{ user, isAuthenticated, loading, setUser, setIsAuthenticated, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

